<div class="login">
    <h1 class="sr-only">{{ 'Create an account' | translate }}</h1>
    <div class="login__content">
        <core-brand-logo [isNotLink]="true"></core-brand-logo>
        <div class="login__wrapper">
            <p>
                <a
                    [core-analytics]="{ action: 'Back to login', category: 'REGISTER' }"
                    class="login__goback"
                    routerLink="/login">
                    <svg class="login__goback-arrow" viewBox="0 0 129 129" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z" />
                    </svg>
                    {{ 'Go back' | translate }}
                </a>
            </p>

            <h2>
                {{ 'Register an account' | translate }}
                <core-dark-mode-toggle [moonDark]="true" class="float-end"></core-dark-mode-toggle>
            </h2>

            <p class="pt-2">
                {{
                    'To register with ' +
                        appName +
                        ', we need to confirm your identity. Please complete the form and click Register.' | translate
                }}
            </p>
            <p>
                {{
                    'You’ll then get an email to the address you supplied. Please open it to complete your registration journey.'
                        | translate
                }}
            </p>

            @if (errorMessage) {
                <div [innerHTML]="errorMessage" class="alert alert-danger"></div>
            }
            @if (successMessage) {
                <div [innerHTML]="successMessage" class="alert alert-success"></div>
            }

            <form (ngSubmit)="register()" [formGroup]="registerForm">
                <div
                    [ngClass]="{
                        'form-group--success': registerForm.get('uuid')!.valid,
                        'form-group--error': registerForm.get('uuid')!.touched && !registerForm.get('uuid')!.valid,
                    }"
                    class="form-group">
                    <label for="uuid">
                        {{ client.getUID() }} *
                        <span class="sr-only">{{ 'required' | translate }}</span>
                    </label>
                    <div class="form-control-wrapper">
                        <input
                            [mask]="client.getUIDMask()"
                            [placeholder]="client.getUIDPlaceholder()"
                            class="form-control form-control-uid"
                            formControlName="uuid"
                            id="uuid"
                            name="uuid"
                            type="text" />
                        <span
                            [hidden]="!registerForm.get('uuid')!.valid"
                            aria-live="polite"
                            class="form-control-feedback">
                            <span class="sr-only">{{ 'Correct' | translate }}</span>
                        </span>
                    </div>
                    <p
                        [hidden]="registerForm.get('uuid')!.valid || !registerForm.get('uuid')!.touched"
                        aria-live="polite"
                        class="small text-danger unconfirmed">
                        {{ 'Please enter a valid' | translate }} {{ client.getUID() }}
                    </p>
                </div>

                <div
                    [ngClass]="{
                        'form-group--success': registerForm.get('email')!.valid,
                        'form-group--error': registerForm.get('email')!.touched && !registerForm.get('email')!.valid,
                    }"
                    class="form-group">
                    <label for="email">
                        {{ 'Email address' | translate }} *
                        <span class="sr-only">{{ 'required' | translate }}</span>
                    </label>
                    <div class="form-control-wrapper">
                        <input
                            (copy)="$event.preventDefault()"
                            (cut)="$event.preventDefault()"
                            (paste)="$event.preventDefault()"
                            autocomplete="off"
                            class="form-control"
                            formControlName="email"
                            id="email"
                            name="email"
                            type="email" />
                        <span
                            [hidden]="!registerForm.get('email')!.valid"
                            aria-live="polite"
                            class="form-control-feedback">
                            <span class="sr-only">{{ 'Correct' | translate }}</span>
                        </span>
                    </div>
                    <p
                        [hidden]="registerForm.get('email')!.valid || !registerForm.get('email')!.touched"
                        aria-live="polite"
                        class="small text-danger unconfirmed">
                        {{ 'Please enter a valid email address' | translate }}
                        e.g. example&#64;mail.com
                    </p>
                </div>

                @if (registerForm.get('email')!.valid) {
                    <div
                        [ngClass]="{
                            'form-group--success':
                                registerForm.get('confirmEmail')!.valid &&
                                registerForm.get('email')!.value === registerForm.get('confirmEmail')!.value,
                            'form-group--error':
                                registerForm.get('confirmEmail')!.touched &&
                                (!registerForm.get('confirmEmail')!.valid ||
                                    registerForm.get('email')!.value !== registerForm.get('confirmEmail')!.value),
                        }"
                        class="form-group">
                        <label for="confirmEmail">
                            {{ 'Confirm your email address' | translate }} *
                            <span class="sr-only">{{ 'required' | translate }}</span>
                        </label>
                        <div class="form-control-wrapper">
                            <input
                                (copy)="$event.preventDefault()"
                                (cut)="$event.preventDefault()"
                                (paste)="$event.preventDefault()"
                                autocomplete="off"
                                class="form-control"
                                formControlName="confirmEmail"
                                id="confirmEmail"
                                name="confirmEmail"
                                type="email" />
                            <span
                                [hidden]="
                                    !registerForm.get('confirmEmail')!.valid ||
                                    registerForm.get('email')!.value !== registerForm.get('confirmEmail')!.value
                                "
                                aria-live="polite"
                                class="form-control-feedback">
                                <span class="sr-only">{{ 'Correct' | translate }}</span>
                            </span>
                        </div>
                        @if (
                            registerForm.get('confirmEmail')!.touched &&
                            registerForm.get('confirmEmail')!.valid &&
                            registerForm.get('email')!.value !== registerForm.get('confirmEmail')!.value
                        ) {
                            <p aria-live="polite" class="small text-danger unconfirmed">
                                {{ 'Please enter the same email address as above' | translate }}
                            </p>
                        }
                    </div>
                }

                <div
                    [ngClass]="{
                        'form-group--success': registerForm.get('dob')!.valid,
                        'form-group--error': registerForm.get('dob')!.touched && !registerForm.get('dob')!.valid,
                    }"
                    class="form-group">
                    <label for="dob"
                        >{{ 'Date of birth' | translate }} *
                        <span class="sr-only">{{ 'required' | translate }}</span></label
                    >
                    <div class="form-control-wrapper">
                        <input
                            [dropSpecialCharacters]="false"
                            class="form-control form-control-medium"
                            formControlName="dob"
                            id="dob"
                            mask="00/00/0000"
                            name="dob"
                            placeholder="DD/MM/YYYY"
                            required
                            type="text" />
                        <span
                            [hidden]="!registerForm.get('dob')!.valid"
                            aria-live="polite"
                            class="form-control-feedback">
                            <span class="sr-only">{{ 'Correct' | translate }}</span>
                        </span>
                    </div>
                    <p
                        [hidden]="registerForm.get('dob')!.valid || !registerForm.get('dob')!.touched"
                        aria-live="polite"
                        class="small text-danger unconfirmed">
                        {{ 'Please enter a valid date' | translate }}
                    </p>
                </div>

                <div
                    [ngClass]="{
                        'form-group--success': registerForm.get('password')!.valid,
                        'form-group--error':
                            registerForm.get('password')!.touched && !registerForm.get('password')!.valid,
                    }"
                    class="form-group">
                    <label for="password">
                        {{ 'Password' | translate }} *
                        <span class="sr-only">{{ 'required' | translate }}</span>
                    </label>

                    <div class="form-control-wrapper form-control-wrapper--password">
                        <input
                            class="form-control"
                            formControlName="password"
                            id="password"
                            name="password"
                            type="{{ passwordType }}" />
                        <span
                            [hidden]="!registerForm.get('password')!.valid"
                            aria-live="polite"
                            class="form-control-feedback">
                            <span class="sr-only">{{ 'Correct' | translate }}</span>
                        </span>
                    </div>
                    <button
                        (click)="togglePasswordType()"
                        [ngClass]="{ 'btn-show-active': passwordType === 'text' }"
                        class="btn btn-show"
                        tabindex="-1"
                        type="button">
                        Toggle to show/hide password
                    </button>

                    <span [hidden]="registerForm.get('password')!.valid" aria-live="polite" class="sr-only">
                        {{ 'Incorrect' | translate }}
                    </span>
                    <p
                        [hidden]="!registerForm.get('password')!.touched || registerForm.get('password')!.valid"
                        class="alert alert-warning small">
                        {{
                            'Passwords must be at least 10 characters long, contain an upper-case and a lower-case letter, a number, and a special character. Avoid common passwords or passwords you use elsewhere.'
                                | translate
                        }}
                    </p>
                </div>

                @if (registerForm.get('password')!.valid) {
                    <div
                        [ngClass]="{
                            'form-group--success':
                                registerForm.get('confirmPassword')!.valid &&
                                registerForm.get('confirmPassword')!.value === registerForm.get('password')!.value,
                            'form-group--error':
                                registerForm.get('confirmPassword')!.touched &&
                                (!registerForm.get('confirmPassword')!.valid ||
                                    registerForm.get('confirmPassword')!.value !== registerForm.get('password')!.value),
                        }"
                        class="form-group">
                        <label for="confirmPassword">
                            {{ 'Confirm your password' | translate }} *
                            <span class="sr-only">{{ 'required' | translate }}</span>
                        </label>
                        <div class="form-control-wrapper form-control-wrapper--password">
                            <input
                                class="form-control"
                                formControlName="confirmPassword"
                                id="confirmPassword"
                                name="confirmPassword"
                                type="{{ passwordType }}" />
                            @if (
                                registerForm.get('confirmPassword')!.touched &&
                                registerForm.get('confirmPassword')!.valid &&
                                registerForm.get('confirmPassword')!.value === registerForm.get('password')!.value
                            ) {
                                <span aria-live="polite" class="form-control-feedback">
                                    <span class="sr-only">{{ 'Correct' | translate }}</span>
                                </span>
                            }
                            <button
                                (click)="togglePasswordType()"
                                [ngClass]="{ 'btn-show-active': passwordType === 'text' }"
                                class="btn btn-show"
                                tabindex="-1"
                                type="button">
                                {{ 'Toggle to show/hide password' | translate }}
                            </button>
                            <p
                                [hidden]="
                                    !registerForm.get('confirmPassword')!.touched ||
                                    registerForm.get('password')!.value === registerForm.get('confirmPassword')!.value
                                "
                                aria-live="polite"
                                class="note small text-danger unconfirmed">
                                {{ 'Please enter the same password as above' | translate }}
                            </p>
                        </div>
                    </div>
                }

                <div class="row no-gutters">
                    <div class="col-6 align-self-center">
                        <!--                        <a-->
                        <!--                            [core-analytics]="{ action: 'Need help', category: 'REGISTER' }"-->
                        <!--                            class="login-link"-->
                        <!--                            routerLink="/login-faqs">-->
                        <!--                            {{ 'Need help?' | translate }}-->
                        <!--                        </a>-->
                    </div>
                    <div class="col-6 my-2">
                        <button
                            [class.spinner]="submitting"
                            [core-analytics]="{ action: 'Register', category: 'REGISTER' }"
                            [disabled]="
                                submitting ||
                                !registerForm.valid ||
                                registerForm.get('password')!.value !== registerForm.get('confirmPassword')!.value
                            "
                            class="btn btn-primary mb-0 float-end"
                            id="js-register-btn"
                            type="submit">
                            <core-spinner name="register"></core-spinner>
                            <span>{{ 'Register' | translate }}</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <core-login-footer></core-login-footer>
    </div>

    <core-demo-config-toggle></core-demo-config-toggle>
</div>
